// extracted by mini-css-extract-plugin
export var arrow = "HeroCarousel-module--arrow--69d31";
export var dot = "HeroCarousel-module--dot--8bc1b";